module.exports = __webpack_public_path__ + "img/newsletter-bg.ec6aec47.webp";